import React from "react";
import { NotFoundPage } from "../../../../components/common";

const NoCandidatesApplicationFound = () => {
  return (
    <div className="no-jobs-found-wrapper">
      <NotFoundPage variant="candidates" />
    </div>
  );
};

export default NoCandidatesApplicationFound;
